import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.23.1_next@14.2.20_@babel+core@7.25.8_@opentelemetry+api@1.9.0_@playwright+t_c643c35ddbe6f04ed73c482f138f9b93/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["GTMContext"] */ "/app/src/features/Analytics/model/context/GTMContext.ts");
;
import(/* webpackMode: "eager", webpackExports: ["GTMInitializer"] */ "/app/src/features/Analytics/ui/GTMInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GTMProvider"] */ "/app/src/features/Analytics/ui/GTMProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HttpProvider"] */ "/app/src/shared/api/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/src/shared/ui/toaster.tsx");
